import { createSelector, createStructuredSelector } from 'reselect';
import { pureCartSelector } from 'src/selectors/cart';
import { skusStateSelector } from 'src/selectors/skus';
import { getMatchingSkuData } from 'src/containers/AddSkuPage/QuestionsFlowPage/skudata';
import { isImmutable } from 'src/utils/helpers';

const skuIdSelector = createSelector(
  (state) => state.getIn(['newItem', 'skuId']),
  (skuId) => skuId,
);

const DATASelector = createSelector(
  [skuIdSelector, pureCartSelector],
  (skuId, cart) => getMatchingSkuData(skuId).decisionTree({ cart }),
);

const skuSelector = createSelector(
  [skuIdSelector, skusStateSelector],
  (skuId, skus) => skus.get(`${skuId}`),
);

const skuNameSelector = createSelector(
  [skuSelector],
  (sku) => sku && sku.get('name'),
);

const skuSeoNameSelector = createSelector(
  [skuSelector],
  (sku) => sku && sku.get('seoName'),
);

const skuBasePriceSelector = createSelector(
  [skuSelector],
  (sku) => {
    if (sku) {
      const basePrice = sku.get('basePrice', 0);
      const remoteSavings = sku.get('remoteSavings', 0);
      return (basePrice + remoteSavings) / 100;
    }
    return 0;
  },
);

const locationSelector = createSelector(
  (state) => state.getIn(['beforeRouteTransition', 'location']),
  (location) => isImmutable(location) ? location.toJS() : location || {} ,
);

export default createStructuredSelector({
  DATA: DATASelector,
  skuId: skuIdSelector,
  skuName: skuNameSelector,
  skuBasePrice: skuBasePriceSelector,
  previousLocation: locationSelector,
  seoName: skuSeoNameSelector,
});
